var _rect, _rect2, _rect3, _clipPath, _circle, _path, _circle2, _circle3, _path2, _ellipse, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlnette({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "jackered",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 8,
    height: 8,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 2,
    width: 8,
    height: 8,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 8,
    height: 8,
    style: {
      fill: "currentColor"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 4,
    height: 4,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 4,
    height: 4,
    fill: "#fff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 240
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 248,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M118 210c8-70 60-118 136-118s128 44 140 118c2 10 2 28-6 36-9 9-29 14-40 8-4-2-7-7-8-12-2-14-3-28-8-40-8-21-24-47-78-47s-72 24-80 47c-5 12-7 28-9 40-1 6-3 10-8 12-11 6-32 2-39-8-6-8-6-24-4-36z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 240c0 82 42 136 96 136s96-54 96-136c0-53-45-96-96-96s-96 43-96 96z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M158 268c-16 0-26-12-26-26 0-11 6-20 14-24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M354 268c16 0 26-12 26-26 0-11-6-20-14-24"
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 242,
    r: 46,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 242,
    r: 46,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M254 242h4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M162 234c-16-8-28-12-42-12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M350 234c16-8 28-12 42-12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M188 246c10 4 20 4 30 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M284 246c10 4 20 4 30 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M252 262c4 12 4 18 0 22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M228 302c18 8 38 8 56 0"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170 344c26 24 146 24 172 0v40c-52 30-120 30-172 0z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 342,
    rx: 96,
    ry: 24,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M256 364 206 476"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M256 364 306 476"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 500c22-92 74-128 126-136 14 36 60 36 74 0 52 8 104 44 126 136H92z",
    fill: "url(#jackered)",
    stroke: "currentColor",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    style: {
      fill: "currentColor"
    },
    d: "M136 292c-6 34 2 54 22 66-18-6-36-18-48-40-8-16-8-34 6-42 8-4 14 6 20 16z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    style: {
      fill: "currentColor"
    },
    d: "M376 292c6 34-2 54-22 66 18-6 36-18 48-40 8-16 8-34-6-42-8-4-14 6-20 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlnette);
export default __webpack_public_path__ + "static/media/alnette.b9f1089b2b6973af399855a5d0f3a6e5.svg";
export { ForwardRef as ReactComponent };